import React from 'react'
import PropTypes from 'prop-types'
import SectionItem from './SectionItem'

const SectionsList = ({
  sections,
  selectedQuestions,
  onSectionSelect,
  onQuestionSelect,
  onSelectAllQuestions,
  onDeselectAllQuestions,
  getSectionSelectedCount
}) => (
  <ul className="list-group">
    {sections?.map(section => (
      <SectionItem
        key={section.id}
        section={section}
        selectedQuestions={selectedQuestions}
        getSectionSelectedCount={getSectionSelectedCount}
        onDeselectAllQuestions={onDeselectAllQuestions}
        onQuestionSelect={onQuestionSelect}
        onSectionSelect={onSectionSelect}
        onSelectAllQuestions={onSelectAllQuestions}
      />
    ))}
  </ul>
)

SectionsList.propTypes = {
  getSectionSelectedCount: PropTypes.func.isRequired,
  onDeselectAllQuestions: PropTypes.func.isRequired,
  onQuestionSelect: PropTypes.func.isRequired,
  onSectionSelect: PropTypes.func.isRequired,
  onSelectAllQuestions: PropTypes.func.isRequired,
  sections: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    questions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired
    }))
  })).isRequired,
  selectedQuestions: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.number)).isRequired
}

export default SectionsList